import { createContext } from 'react'

const SelectOptionsContext = createContext()

export default SelectOptionsContext
